import { createContext } from "react"

const TierContext = createContext({})

export default TierContext
